import { call, put } from 'redux-saga/effects';
import { types } from '@reducers/organizationData';
import * as Api from '@utils/Api';

export function* fetchAggregateMetadata(action) {
  const { organizationUUID } = action;
  if (!organizationUUID) {
    throw new Error(
      'Missing required parameters for fetching aggregate metadata'
    );
  }
  const response = yield call(
    Api.get,
    `organizations/${organizationUUID}/meta-aggregate`
  );
  if (!response.success) {
    yield put({
      type: types.AGGREGATE_METADATA_FAILURE,
      error: 'An error occurred while fetching aggregate metadata',
    });
  } else {
    yield put({
      type: types.AGGREGATE_METADATA_SUCCESS,
      organizationUUID,
      data: response.data,
    });
  }
}

export function* fetchOrganizationPullRequestAuthors({
  organizationUUID,
  inputValue,
}) {
  if (!organizationUUID || !inputValue) {
    throw new Error(
      'Missing required parameters for fetching pull request authors for an organization.',
      organizationUUID,
      inputValue
    );
  }
  const url = `organizations/${organizationUUID}/pull-requests/authors?username=${inputValue}`;
  const response = yield call(Api.get, url);
  if (!response.success) {
    yield put({
      type: types.ORGANIZATION_PULL_REQUEST_AUTHORS_FAILURE,
      organizationUUID,
      error: response.data ? response.data.error_message : 'Unknown Error',
    });
  } else {
    yield put({
      type: types.ORGANIZATION_PULL_REQUEST_AUTHORS_SUCCESS,
      organizationUUID,
      data: response.data,
    });
  }
}
